import { render, staticRenderFns } from "./scoreboard_statbox.vue?vue&type=template&id=941710dc&"
import script from "./scoreboard_statbox.vue?vue&type=script&lang=js&"
export * from "./scoreboard_statbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports